/**
 * Especial → SESSP → Gestão de Faturas (#MT-9B4E512).
 * Placeholder até o painel operacional (Fase 1). Exige ACL GET /especial/sessp.
 */
import { fetchEspecialAcl, hasEspecialTenant } from '../utils/especial-acl.js';

export default async function especial_sessp_faturas() {
	const work = document.getElementById('workarea');
	if (!work) return;
	const acl = await fetchEspecialAcl();
	if (!hasEspecialTenant('sessp', acl)) {
		work.innerHTML = `
			<div class="title">Gestão de Faturas</div>
			<p class="mts" style="max-width: 40rem;">
				Seu usuário não tem permissão para o módulo <strong>Especial → SESSP</strong>.
				Peça ao administrador para incluir o endpoint
				<strong>GET /especial/sessp</strong> no grupo (grupo <strong>ESPECIAL SESSP</strong>
				ou equivalente).
			</p>
		`;
		return;
	}
	work.innerHTML = `
		<div class="title">SESSP — Gestão de Faturas</div>
		<p class="mts" style="max-width: 40rem;">
			Painel em elaboração. Em breve: status das faturas, SLA, origem Farmanet/GSNET,
			DRS/programa e detalhe dos itens.
		</p>
	`;
}
